import { createSlice } from "@reduxjs/toolkit";
import { fetchReferredCandidatesThunk } from "./thunks";
import { IReferralsState } from "./types";

const initialState: IReferralsState = {
  inProgress: false,
  error: null,
  referralList: [],
  pagination: null,
  token: null,
};

const referralsSlice = createSlice({
  name: "referrals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferredCandidatesThunk.pending, (state) => {
        state.inProgress = true;
        state.error = null;
      })
      .addCase(fetchReferredCandidatesThunk.fulfilled, (state, action) => {
        state.inProgress = false;
        state.referralList = action.payload.candidates.data;
        state.pagination = {
          current_page: action.payload.candidates.current_page,
          per_page: action.payload.candidates.per_page,
          total: action.payload.candidates.total,
          last_page: action.payload.candidates.last_page,
          next_page_url: action.payload.candidates.next_page_url,
          prev_page_url: action.payload.candidates.prev_page_url,
          links: action.payload.candidates.links,
        };
      })
      .addCase(fetchReferredCandidatesThunk.rejected, (state, action) => {
        state.inProgress = false;
        state.error =
          action.payload || "An error occurred while fetching referrals.";
      });
  },
});

export default referralsSlice.reducer;
